import type { FC } from 'react';

import { Stack, Box } from '@eneco/sparky';
import { useContent } from '@sitecore/common';
import { DynamicPricingTariffsRendering } from '@sitecore/types/DynamicPricingTariffs';

import { LegendItem } from './LegendItem';
import { useDynamicPricingTariffsOptional } from '../../../../hooks/useDynamicPricingTariffs';

export const Legend: FC = () => {
  const context = useDynamicPricingTariffsOptional();
  const { fields } = useContent<DynamicPricingTariffsRendering>();

  if (!context) return null;
  const { data, averagePrice, selectedView, selectedProduct, showTotal } = context;

  const isCheapRating = data?.some(item => item?.rating === 'cheap');
  const isExpensiveRating = data?.some(item => item?.rating === 'expensive');
  const isMissingDataPoints = data?.some(item => Number.isNaN(showTotal ? item?.total : item?.wholesale));

  return (
    <Box padding="6">
      <Stack gap="6" direction="row" alignX="center" alignY="center" wrap>
        {averagePrice && <LegendItem label={fields?.averagePriceText?.value} type="averagePrice" />}
        {isMissingDataPoints && <LegendItem label={fields?.unknownTariffLabel?.value} type="unknownPrice" />}
        {selectedView === 'day' && selectedProduct === 'electricity' ? (
          <>
            {isCheapRating && <LegendItem type="cheapTariff" label={fields?.cheapTariffLabel?.value} />}
            {isExpensiveRating && <LegendItem type="expensiveTariff" label={fields?.expensiveTariffLabel?.value} />}
          </>
        ) : (
          <>
            {selectedProduct === 'electricity' && (
              <LegendItem type={`${selectedProduct}Product`} label={fields?.electricityProductLabel?.value} />
            )}
            {selectedProduct === 'gas' && (
              <LegendItem type={`${selectedProduct}Product`} label={fields?.gasProductLabel?.value} />
            )}
          </>
        )}
      </Stack>
    </Box>
  );
};
